<ng-container *transloco="let t">

  <div class="modal-header">

    <h2>{{header}}</h2>

    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />

    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
      (click)="activeModal.dismiss('Cross click')">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  </div>

  <div class="modal-body py-10 px-lg-17">
    <form #assetInfoForm="ngForm" class="form" novalidate id="assetInfoForm" name="assetInfoForm">
      <div class="me-n7 pe-7">

        @if (!isMultiAccountMode) {
          <!-- ─── Single-asset editor ─────────────────────────────────────── -->
          <div class="row mb-8">
            @if (!isHidden('asset.assetType')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.assetType')}">{{getLabel('asset.assetType', t('wizard.assets.assetType'))}}</label>
                <select name="assetType"
                  [required]="isRequired('asset.assetType')"
                  [ngClass]="{'is-invalid' : assetType && assetType.touched && assetType.invalid}"
                  #assetType="ngModel" class="form-select form-select-solid" [(ngModel)]="asset!.assetType"
                  data-control="select2" data-hide-search="true" data-placeholder="Choose one" (change)='onAssetTypeSelected(assetType.value)'>
                  <option [ngValue]="null">{{ t('common.selectOne') }}</option>
                  @for (assetType of assetTypes; track assetType.value; let i = $index) {
                    <option #incomeItem [ngValue]="assetType.value">{{assetType.name}}</option>
                  }
                </select>
                <div class="invalid-feedback">{{ t('wizard.assets.assetTypeRequired') }}</div>
              </div>
            }
            @if (!isHidden('asset.cashMarketValue')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.cashMarketValue')}">{{getLabel('asset.cashMarketValue', t('wizard.assets.amount'))}}</label>
                <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [ngClass]="{'is-invalid' : amount && amount.touched && amount.invalid}"
                #amount="ngModel" [required]="isRequired('asset.cashMarketValue')" [(ngModel)]="asset!.cashMarketValue" placeholder="" name="amount" />
                <div class="invalid-feedback">{{ t('wizard.assets.amountRequired') }}</div>
              </div>
            }
          </div>
          @if (assetRequiresInstitution || lockedInstitution) {
            <div class="row mb-8">
              @if (!isHidden('asset.depository')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.depository')}">{{getLabel('asset.depository', t('wizard.assets.nameOfBank'))}}</label>
                  @if (lockedInstitution) {
                    <div class="form-control form-control-solid bg-light d-flex align-items-center">
                      <span class="text-gray-800 fw-bold">{{ lockedInstitution }}</span>
                    </div>
                    <input type="hidden" name="instituition" [ngModel]="asset!.depository" />
                  } @else {
                    <input class="form-select form-select-solid"
                      style="cursor: pointer;"
                      [required]="isRequired('asset.depository')"
                      [ngClass]="{'is-invalid' : instituition && instituition.touched && instituition.invalid}"
                      #instituition="ngModel"
                      #institutionTypeahead="ngbTypeahead"
                      [(ngModel)]="asset!.depository"
                      [ngbTypeahead]="searchInstitutions"
                      (focus)="institutionFocus$.next($any($event).target.value)"
                      (click)="institutionClick$.next($any($event).target.value)"
                      container="body"
                      placeholder=""
                      name="instituition" />
                    <div class="invalid-feedback">{{ t('wizard.assets.institutionRequired') }}</div>
                  }
                </div>
              }
              @if (!isHidden('asset.accountNumber')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.accountNumber')}">{{getLabel('asset.accountNumber', t('wizard.assets.accountNumber'))}}</label>
                  <input class="form-control form-control-solid" [required]="isRequired('asset.accountNumber')"
                  [ngClass]="{'is-invalid' : accountNumber && accountNumber.touched && accountNumber.invalid}"
                  #accountNumber="ngModel" [(ngModel)]="asset!.accountNumber" placeholder="" name="accountNumber" />
                  <div class="invalid-feedback">{{ t('wizard.assets.accountNumberRequired') }}</div>
                </div>
              }
            </div>
          }
          @if (asset!.assetType === 'Automobile') {
            <div class="row mb-8">
              @if (!isHidden('asset.makeModel')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.makeModel')}">{{getLabel('asset.makeModel', t('wizard.assets.makeModel'))}}</label>
                  <input class="form-control form-control-solid" [required]="isRequired('asset.makeModel')"
                  [ngClass]="{'is-invalid' : makeModel && makeModel.touched && makeModel.invalid}"
                  #makeModel="ngModel" [(ngModel)]="asset!.makeModel" placeholder="" name="makeModel" />
                  <div class="invalid-feedback">{{ t('wizard.assets.makeModelRequired') }}</div>
                </div>
              }
              @if (!isHidden('asset.year')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.year')}">{{getLabel('asset.year', t('wizard.assets.year'))}}</label>
                  <input class="form-control form-control-solid"
                  [ngClass]="{'is-invalid' : year && year.touched && year.invalid}"
                  #year="ngModel" [required]="isRequired('asset.year')" [(ngModel)]="asset!.year" placeholder="" name="year" />
                  <div class="invalid-feedback">{{ t('wizard.assets.yearRequired') }}</div>
                </div>
              }
            </div>
          }
          @if (asset!.assetType === 'PendingNetSaleProceedsFromRealEstateAssets') {
            <div>
              <asset-pending-net-sale-proceeds [address]="address" [asset]="asset" [fieldsToConfig]="fieldConfig" ></asset-pending-net-sale-proceeds>
            </div>
          }
          @if (asset!.assetType === 'CashGift' || asset!.assetType === 'Grant') {
            <div class="row mb-8">
              @if (!isHidden('asset.giftOrGrantSource')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.giftOrGrantSource')}">
                    {{getLabel('asset.giftOrGrantSource', t('wizard.assets.source'))}}
                  </label>
                  <select name="giftOrGrantSource"
                    [required]="isRequired('asset.giftOrGrantSource')"
                    [ngClass]="{'is-invalid' : giftOrGrantSource && giftOrGrantSource.touched && giftOrGrantSource.invalid}"
                    #giftOrGrantSource="ngModel" class="form-select form-select-solid" [(ngModel)]="asset!.giftOrGrantSource"
                    data-control="select2" data-hide-search="true" data-placeholder="Select one...">
                    <option [ngValue]="null">{{ t('common.selectOne') }}</option>
                    @for (source of giftOrGrantSources; track source.value) {
                      <option [ngValue]="source.value">{{source.name}}</option>
                    }
                  </select>
                  <div class="invalid-feedback">{{ t('wizard.assets.sourceRequired') }}</div>
                </div>
              }
            </div>
          }
          <!-- LLS-641: Cash Gift only (not Grant) - "Yes" pre-selects Gift as the Down Payment Source on the Loan Type step -->
          @if (asset!.assetType === 'CashGift' && !isHidden('asset.isDownPaymentSource')) {
            <div class="row mb-8">
              <div class="col-md-12 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.isDownPaymentSource')}">
                  {{getLabel('asset.isDownPaymentSource', t('wizard.assets.cashGiftForDownPayment'))}}
                </label>
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="radio" name="isDownPaymentSource" id="isDownPaymentSourceYes"
                      [value]="true" [required]="isRequired('asset.isDownPaymentSource')"
                      [ngClass]="{'is-invalid' : isDownPaymentSource && isDownPaymentSource.touched && isDownPaymentSource.invalid}"
                      [(ngModel)]="asset!.isDownPaymentSource" #isDownPaymentSource="ngModel" />
                    <label class="form-check-label" for="isDownPaymentSourceYes">{{ t('common.yes') }}</label>
                  </div>
                  <div class="form-check form-check-custom form-check-solid ms-8">
                    <input class="form-check-input" type="radio" name="isDownPaymentSource" id="isDownPaymentSourceNo"
                      [value]="false" [required]="isRequired('asset.isDownPaymentSource')"
                      [ngClass]="{'is-invalid' : isDownPaymentSource && isDownPaymentSource.touched && isDownPaymentSource.invalid}"
                      [(ngModel)]="asset!.isDownPaymentSource" #isDownPaymentSource="ngModel" />
                    <label class="form-check-label" for="isDownPaymentSourceNo">{{ t('common.no') }}</label>
                  </div>
                </div>
                @if (isDownPaymentSource && isDownPaymentSource.touched && isDownPaymentSource.invalid) {
                  <div class="text-danger fs-7 mt-2">{{ t('wizard.assets.cashGiftForDownPaymentRequired') }}</div>
                }
              </div>
            </div>
          }
          @if (!inCoApplyFlow) {
            <div class="row mb-5">
              <div class="col-md-12 fv-row">
                <label class="required form-label mb-2">{{ t('wizard.assets.whoOwnsThisAsset') }}</label>
                <div class="pl-20">
                  <multi-checkbox-picker [possibleChoices]="possibleBorrowers" [selectedItems]="selectedBorrowers" [disabledChoices]="disabledBorrowers"></multi-checkbox-picker>
                </div>
              </div>
            </div>
          }
        } @else {
          <!-- ─── Bulk-account editor ────────────────────────────────────── -->
          <div class="accounts-card mb-2">
            @if (lockedInstitution || inEditMode) {
              <!-- Institution is fixed: show it as a card header -->
              <div class="accounts-card-header">
                <div class="accounts-card-title">
                  <span class="svg-icon svg-icon-2x svg-icon-primary me-3" style="padding-bottom: 2px;">
                    <stockholm-bank-svg-icon></stockholm-bank-svg-icon>
                  </span>
                  <span class="fs-5 fw-bolder text-gray-800">{{ t('wizard.assets.accountsAt') }} {{ lockedInstitution || asset!.depository }}</span>
                </div>
                <button type="button" class="btn btn-sm btn-light-primary" (click)="addAccountRow()">
                  <i class="bi bi-plus-lg me-1"></i>{{ t('wizard.assets.addAccount') }}
                </button>
              </div>
            } @else {
              <!-- Institution typeahead — user picks the bank, then the table appears -->
              <div class="accounts-card-institution-picker">
                <label class="form-label mb-2 required">{{ t('wizard.assets.nameOfBank') }}</label>
                <input class="form-select form-select-solid"
                  style="cursor: pointer;"
                  required
                  [ngClass]="{'is-invalid' : bulkInstitution && bulkInstitution.touched && bulkInstitution.invalid}"
                  #bulkInstitution="ngModel"
                  #institutionTypeahead="ngbTypeahead"
                  [ngModel]="asset!.depository"
                  (ngModelChange)="onDepositoryChanged($event)"
                  [ngbTypeahead]="searchInstitutions"
                  (selectItem)="onInstitutionSelected($event)"
                  (change)="commitInstitution()"
                  (focus)="institutionFocus$.next($any($event).target.value)"
                  (click)="institutionClick$.next($any($event).target.value)"
                  container="body"
                  placeholder=""
                  name="bulkInstitution" />
                <div class="invalid-feedback">{{ t('wizard.assets.institutionRequired') }}</div>
              </div>

              @if (hasCommittedInstitution) {
                <div class="accounts-card-header">
                  <div class="accounts-card-title">
                    <span class="svg-icon svg-icon-2x svg-icon-primary me-3" style="padding-bottom: 2px;">
                      <stockholm-bank-svg-icon></stockholm-bank-svg-icon>
                    </span>
                    <span class="fs-5 fw-bolder text-gray-800">{{ t('wizard.assets.accountsAt') }} {{ asset!.depository }}</span>
                  </div>
                  <button type="button" class="btn btn-sm btn-light-primary" (click)="addAccountRow()">
                    <i class="bi bi-plus-lg me-1"></i>{{ t('wizard.assets.addAccount') }}
                  </button>
                </div>
              }
            }

            @if (hasCommittedInstitution) {
            <div class="accounts-grid" [class.with-owners]="!inCoApplyFlow">
              <div class="accounts-grid-header">
                <span class="required">{{ t('wizard.assets.assetType') }}</span>
              </div>
              <div class="accounts-grid-header">
                <span class="required">{{ t('wizard.assets.amount') }}</span>
              </div>
              <div class="accounts-grid-header">
                <span [ngClass]="{'required': isRequired('asset.accountNumber')}">{{ t('wizard.assets.accountNumber') }}</span>
              </div>
              @if (!inCoApplyFlow) {
                <div class="accounts-grid-header">
                  <span class="required">{{ t('wizard.assets.owners') }}</span>
                </div>
              }
              <div class="accounts-grid-header accounts-grid-header--actions" aria-hidden="true"></div>

              @for (row of accountRows; track row.rowId; let idx = $index) {
                <div class="accounts-row">
                  <div class="accounts-grid-cell">
                    <label class="accounts-grid-cell-label">
                      <span class="required">{{ t('wizard.assets.assetType') }}</span>
                    </label>
                    <select class="form-select form-select-solid"
                      [(ngModel)]="row.assetType"
                      [name]="'rowType-' + row.rowId"
                      #rowType="ngModel"
                      required
                      [ngClass]="{'is-invalid' : rowType.touched && rowType.invalid}"
                      data-control="select2" data-hide-search="true">
                      <option [ngValue]="null">{{ t('common.selectOne') }}</option>
                      @for (typeOption of assetTypes; track typeOption.value) {
                        <option [ngValue]="typeOption.value">{{ typeOption.name }}</option>
                      }
                    </select>
                  </div>
                  <div class="accounts-grid-cell">
                    <label class="accounts-grid-cell-label">
                      <span class="required">{{ t('wizard.assets.amount') }}</span>
                    </label>
                    <input class="form-control form-control-solid"
                      mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                      [(ngModel)]="row.cashMarketValue"
                      [name]="'rowAmount-' + row.rowId"
                      #rowAmount="ngModel"
                      required
                      [ngClass]="{'is-invalid' : rowAmount.touched && rowAmount.invalid}"
                      placeholder="" />
                  </div>
                  <div class="accounts-grid-cell">
                    <label class="accounts-grid-cell-label">
                      <span [ngClass]="{'required': isRequired('asset.accountNumber')}">{{ t('wizard.assets.accountNumber') }}</span>
                    </label>
                    <input class="form-control form-control-solid"
                      [(ngModel)]="row.accountNumber"
                      [name]="'rowAccount-' + row.rowId"
                      #rowAccount="ngModel"
                      [required]="isRequired('asset.accountNumber')"
                      [ngClass]="{'is-invalid' : rowAccount.touched && rowAccount.invalid}"
                      placeholder="" />
                  </div>
                  @if (!inCoApplyFlow) {
                    <div class="accounts-grid-cell accounts-grid-cell--owners">
                      <label class="accounts-grid-cell-label">
                        <span class="required">{{ t('wizard.assets.owners') }}</span>
                      </label>
                      <multi-checkbox-picker
                        [possibleChoices]="possibleBorrowers"
                        [selectedItems]="row.selectedBorrowers"
                        [disabledChoices]="disabledBorrowers">
                      </multi-checkbox-picker>
                    </div>
                  }
                  <div class="accounts-grid-cell accounts-grid-cell--actions">
                    <button type="button"
                      class="btn btn-icon btn-sm btn-light-danger"
                      [disabled]="accountRows.length <= 1"
                      [attr.aria-label]="t('wizard.assets.removeAccount')"
                      (click)="removeAccountRow(row.rowId)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
            }
          </div>
        }
      </div>
    </form>
  </div>

  <div class="modal-footer flex-center">
    <button type="button" class="btn btn-white me-3" (click)="activeModal.close('Cancel click')">{{ t('common.cancel') }}</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
  </div>

</ng-container>
